import {ValueObject} from '@s-ui/domain'

export class ShowLastCallValueObject extends ValueObject {
  /**
   * @param {Object}  data
   * @param {Boolean} data.show
   * @param {String}  data.reason
   * */
}
